import React from 'react';

const StyledH3Heading=({children ,children2,fontColor,fontColor2})=>{
    return(
<h3 className={`text-h3 font-bricolage ${fontColor}`}>
{children}<span className={`${fontColor2}`}>{children2}</span>
</h3>
    );
};
export default StyledH3Heading;